import LanguageEntity from '../entities/Language.Entity';
import { apiGet } from '../support/helpers/ApiConnection.Helper';

export default function getLanguages(abortSignal: AbortSignal): Promise<Array<LanguageEntity>> {    
    return apiGet<Array<LanguageEntity>>('/languages',abortSignal);
}
